import React from "react";

const Notification = ({
  desc,
  title,
  onClick,
  btnText,
  headerText,
  btnText2 = "",
  onClick2 = () => {}
}) => {
  return (
    <section className="payment-failed">
      <div className="payment-failed__flex">
        <h3>{headerText}</h3>
        <div>
          {btnText2 && (
            <button className="renew-btn" onClick={onClick2}>
              {btnText2}
            </button>
          )}
          <button className="update-btn" onClick={onClick}>
            {btnText}
          </button>
        </div>
      </div>
      <h2 className="title">{title}</h2>
      <p className="info">
        {desc}
        <a
          href="mailto:support@heylime.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          support@heylime.com
        </a>
        .
      </p>
    </section>
  );
};

export default Notification;
